import React from 'react';

import { JRCHtml } from 'components/JRCHtml/JRCHtml';

import {
    WidgetDatasourceValues,
    WidgetTableColumn,
    WidgetTableColumnTypes,
    WidgetTableColumnsData,
} from 'jamespot-user-api';

import { ensureIsNumber, ensureIsStringOrNumber, ensureIsUrl } from './ensure';
import { labelize } from './utils';
import { JRCDate } from 'components/JRCDate/JRCDate';

import { JRCWidgetTableTdRendererText } from './JRCWidgetTableTdRendererText';

export const JRCWidgetTableTdRenderer = ({
    value,
    name,
    type,
    backgroundColor = '#fff',
    tableColumnsData,
    url,
}: {
    col: WidgetTableColumn;
    type: WidgetTableColumnTypes;
    name: string;
    tableColumnsData: WidgetTableColumnsData;
    backgroundColor: string;
    value: WidgetDatasourceValues;
    url?: string;
}) => {
    const columnData = tableColumnsData?.find((el) => el.name === name);
    switch (type) {
        case 'number':
            if (ensureIsNumber(value)) {
                if (columnData?.numberFormat === 'filesize') {
                    return <>{(value / 1024 ** 2).toFixed(1)}Mo</>;
                } else {
                    return <>{value.toLocaleString(columnData?.numberFormat)}</>;
                }
            }
            break;
        case 'file':
            if (ensureIsUrl(value)) {
                return (
                    <a href={value.url} target="_blank" rel="noreferrer">
                        {labelize(name, tableColumnsData, value.title)}
                    </a>
                );
            }
            break;
        case 'date':
            if (ensureIsStringOrNumber(value)) {
                return <JRCDate date={value} format={'date'} />;
            }
            break;
        case 'datetime':
            if (ensureIsStringOrNumber(value)) {
                return columnData?.dateFormat ? <JRCDate date={value} format={columnData?.dateFormat} /> : <>{value}</>;
            }
            break;
        case 'email':
            if (ensureIsStringOrNumber(value)) {
                return (
                    <a href={`mailto:${value}`} target="_blank" rel="noreferrer">
                        {value}
                    </a>
                );
            }
            break;
        case 'title':
            if (ensureIsStringOrNumber(value)) {
                if (url) {
                    return (
                        <a href={url} target="_blank" rel="noreferrer">
                            <JRCHtml __html={String(value)} />
                        </a>
                    );
                }
                return <JRCHtml __html={String(value)} />;
            }
            break;
        case 'url':
            if (ensureIsUrl(value)) {
                return (
                    <a href={value.url} target="_blank" rel="noreferrer">
                        {labelize(name, tableColumnsData, value.title)}
                    </a>
                );
            }
            break;
        case 'uri':
            if (ensureIsUrl(value)) {
                return (
                    <a href={value.url} target="_blank" rel="noreferrer">
                        {labelize(name, tableColumnsData, value.title)}
                    </a>
                );
            }
            break;
        case 'select':
            if (ensureIsStringOrNumber(value)) {
                return <JRCHtml __html={String(value)} />;
            }
            break;
        default:
        case 'text':
            return (
                <JRCWidgetTableTdRendererText
                    name={name}
                    value={value}
                    backgroundColor={backgroundColor}
                    tableColumnsData={tableColumnsData}
                />
            );
    }

    return <MissingValue />;
};

const MissingValue = () => {
    return <></>;
};
